(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dealer-credit-application"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('DealerCreditApplication');
    if (!form) return;
    const reference = form.querySelector('[data-application-reference]');
    if (reference && !reference.value) reference.value = `DF-${Date.now().toString(36).toUpperCase()}`;
    const copyToggle = form.querySelector('[data-copy-registered-address]');
    if (copyToggle) copyToggle.addEventListener('change', () => {
      form.querySelectorAll('[data-registered-address]').forEach((source) => {
        const target = form.querySelector(`[data-delivery-address="${source.dataset.registeredAddress}"]`);
        if (!target) return;
        if (copyToggle.checked) target.value = source.value;
        target.readOnly = copyToggle.checked;
      });
    });
    const success = form.querySelector('[data-form-success]');
    const error = form.querySelector('[data-form-error]');
    const errorMessage = form.querySelector('[data-form-error-message]');
    const submitButton = form.querySelector('[data-submit-button]');
    const submitLabel = submitButton.textContent;
    const controls = [...form.querySelectorAll('input, textarea, select')].filter((control) => control.type !== 'hidden');
    const isValidUKDate = (control) => {
      if (control.dataset.dateField === undefined || !control.value) return true;
      const match = control.value.match(/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/);
      if (!match) return false;
      const day = Number(match[1]);
      const month = Number(match[2]);
      const year = Number(match[3]);
      const date = new Date(Date.UTC(year, month - 1, day));
      return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
    };
    const validationMessage = (control) => {
      control.setCustomValidity('');
      if (!isValidUKDate(control)) return form.dataset.validationDate;
      if (control.validity.valid) return '';
      if (control.validity.valueMissing) {
        if (control.type === 'checkbox' || control.type === 'radio') return form.dataset.validationOption;
        return form.dataset.validationRequired;
      }
      if (control.validity.typeMismatch && control.type === 'email') return form.dataset.validationEmail;
      if (control.validity.badInput && control.type === 'number') return form.dataset.validationNumber;
      if (control.validity.badInput && control.type === 'date') return form.dataset.validationDate;
      if (control.dataset.dateField !== undefined && control.validity.patternMismatch) return form.dataset.validationDate;
      if (control.validity.rangeUnderflow || control.validity.rangeOverflow || control.validity.stepMismatch) return form.dataset.validationNumber;
      if (control.validity.patternMismatch || control.validity.tooLong || control.validity.tooShort) return form.dataset.validationPattern;
      return form.dataset.validationRequired;
    };
    const validateControl = (control) => {
      const message = validationMessage(control);
      if (message) control.setCustomValidity(message);
      return !message;
    };
    form.addEventListener('invalid', (event) => validateControl(event.target), true);
    form.addEventListener('input', (event) => {
      event.target.setCustomValidity('');
      if (event.target.dataset.dateField !== undefined) {
        const digits = event.target.value.replace(/[^0-9]/g, '').slice(0, 8);
        event.target.value = digits.length > 4 ? `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}` : digits.length > 2 ? `${digits.slice(0, 2)}/${digits.slice(2)}` : digits;
      }
      if (event.target.autocomplete && event.target.autocomplete.includes('postal-code')) event.target.value = event.target.value.toUpperCase();
    });
    form.addEventListener('change', (event) => event.target.setCustomValidity(''));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      success.hidden = true;
      error.hidden = true;
      controls.forEach(validateControl);
      const firstInvalid = controls.find((control) => !control.validity.valid);
      if (firstInvalid) {
        errorMessage.textContent = form.dataset.validationSummary;
        error.hidden = false;
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalid.focus({ preventScroll: true });
        firstInvalid.reportValidity();
        return;
      }
      const endpoint = form.dataset.endpoint;
      if (!endpoint) {
        errorMessage.textContent = form.dataset.configError;
        error.hidden = false;
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.textContent = form.dataset.submittingLabel;
      const payload = {};
      new FormData(form).forEach((value, key) => {
        if (typeof value === 'string') payload[key] = value;
      });
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Submission failed');
        form.reset();
        success.hidden = false;
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (submissionError) {
        errorMessage.textContent = form.dataset.submitError;
        error.hidden = false;
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } finally {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        submitButton.textContent = submitLabel;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
